import i18next from 'i18next'
import { FI, SV, EN } from 'common/src/vtj/browser/localization'

export default function translationInit(translations, options) {
  // eslint-disable-next-line import/no-named-as-default-member
  const instance = i18next.createInstance()

  instance.init({
    interpolation: {
      escapeValue: false,
    },
    lng: FI,
    initImmediate: false, // Makes the init function synchronous. Otherwise .init will return a promise.
    resources: {
      [FI]: { translation: translations[FI] },
      [SV]: { translation: translations[SV] },
      [EN]: { translation: translations[EN] },
    },
    ...options,
  })

  return instance
}
